<template>
  <div>
    <h5>制卡</h5>
    <el-form ref="form" :model="cards" :rules="rules">
      <el-form-item prop="count" label="张数">
        <el-input type="number" v-model="cards.count"></el-input>
      </el-form-item>
      <el-form-item prop="type" label="类型">
        <el-select v-model="cards.type">
          <el-option value="1" label="景区卡"/>
          <el-option value="2" label="酒店卡"/>
        </el-select>
      </el-form-item>
      <el-form-item prop="type" label="价格">
        <el-input type="number" v-model="cards.price"></el-input>
      </el-form-item>
      <el-form-item prop="startSerialNumber" label="起始号码">
        <el-input type="number" v-model="cards.startSerialNumber"></el-input>
      </el-form-item>
      <div v-if="!serialNumberAvailable" style="color: red;">
        <p>无法从{{ cards.startSerialNumber }} 制卡 至 {{ +cards.startSerialNumber + +cards.count }} 。该号段不是空白。</p>
        <p>以下卡号已被占用：</p>
        <p>
          {{ existedCards }}
        </p>
      </div>
      <el-button :disabled="!serialNumberAvailable" :loading="loading" type="primary" @click="submit">
        确认制卡
      </el-button>
    </el-form>
  </div>
</template>
<script>
import {reactive, ref, watch} from 'vue'
import {ElMessageBox} from 'element-plus'
import axios from '../../../request'

export default {
  setup() {
    const form = ref('')
    const cards = reactive({
      count: '',
      type: '',
      startSerialNumber: '',
      price: null
    })
    const loading = ref(false)
    const serialNumberAvailable = ref(true)
    const existedCards = ref([])
    const rules = reactive({
      count: [
        {required: true, message: '数量不能为空且必须为数字'},
        {
          validator: (rule, value, cb) => {
            if (value > 0 && value <= 1000) {
              cb()
            } else {
              cb('一次制卡数量必须为 1 到 1000 张之间')
            }
          }
        }
      ],
      type: [
        {required: true, message: '类型不能为空'},
      ],
      price: [
        {required: true, message: '价格不能为空'},
      ],
      startSerialNumber: [
        {required: true, message: '起始号码不能为空'},
      ]
    })

    watch(() => cards.type, (type) => {
      cards.price = (+type === 1 ? 168 : 365)
    })

    const checkExisted = async () => {
      if (!+cards.count) return
      if (cards.startSerialNumber <= 0) return
      const {result, existed} = await axios.get('/cards/if_can_create', {
        params: {
          startSerialNumber: cards.startSerialNumber,
          count: cards.count
        }
      })
      serialNumberAvailable.value = result
      existedCards.value = existed || []
    }

    watch(() => cards.startSerialNumber, checkExisted)

    watch(() => cards.count, checkExisted)

    const submit = () => {
      form.value?.validate(async pass => {
        if (!pass) return
        try {
          await ElMessageBox.confirm(
              '确认制卡？',
              '请确认',
              {
                confirmButtonText: '确认',
                cancelButtonText: '取消',
                type: 'warning',
              }
          )
          loading.value = true
          await axios.post(`/cards`, cards)
          cards.count = ''
          cards.type = ''
          cards.startSerialNumber = ''
          cards.price = null
        } catch {

        } finally {
          loading.value = false
        }
      })
    }

    return {
      loading,
      form,
      submit,
      cards,
      rules,
      serialNumberAvailable,
      existedCards
    }
  }
}
</script>
